<template>
  <form
    class="flex w-full flex-col items-center lg:items-end"
    @submit="handleSubmit">
    <SectionNewsletterFormInput
      v-model="inputEmail"
      :state="state"
      :label="inputLabel"
      :placeholder="inputPlaceholder"
      class="sm:w-96">
      <SectionNewsletterFormButton
        :state="state"
        :label="submitLabel" />
    </SectionNewsletterFormInput>

    <SectionNewsletterFormCheckbox
      :state="state"
      :copy="consentLabel" />

    <SectionNewsletterFormToast
      :state="state"
      :success-message="successMessage"
      :error-message="errorMessage" />
  </form>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  import type { ContactListId } from '~/constants/email'

  import useNewsletter from '../../../composables/use-newsletter'

  type FormToastProps = {
    contactListId: ContactListId
    inputPlaceholder: string
    inputLabel: string
    submitLabel: string
    consentLabel: string
    successMessage: string
    errorMessage: string
  }

  const props = defineProps<FormToastProps>()
  const { subscribe, state } = useNewsletter()

  const inputEmail = ref('')

  async function handleSubmit(e: Event) {
    e.preventDefault()

    subscribe(inputEmail.value, props.contactListId)
      .then(() => {
        inputEmail.value = ''
      })
      .catch(() => {
        console.error('Subscribe failed')
      })
  }
</script>
